import type { MessageResponse } from '@/models/chat';

// converts | characters to <br> tags
export const convertMultilineContent = (content?: string | null): string | undefined | null => {
  if (content === undefined) return undefined;
  if (content === null) return null;

  return content.replaceAll('|', '<br>').replaceAll('\n', '<br>');
};

// twill sends empty image fields (not uploaded) as empty array
export const isImageEmpty = (image?: any) => {
  return !image || (typeof image === 'string' && !image.length) || (Array.isArray(image) && !image.length);
};

export const ChatMaxHeight = 600;

export const ChatLikeEmoji = '👍';
export const ChatDislikeEmoji = '👎';
export const ChatRegenerateEmoji = '🔄';

export const isMessageLiked = (message: MessageResponse) => {
  return message.emojis?.name === ChatLikeEmoji;
};

export const isMessageDisliked = (message: MessageResponse) => {
  return message.emojis?.name === ChatDislikeEmoji;
};

export const isMessageRegenerated = (message: MessageResponse) => {
  return message.emojis?.name === ChatRegenerateEmoji;
};
